const _ = require('underscore');

module.exports = _;
